export default "__VITE_ASSET__ClNWzKRt__"